import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=396b4554&scoped=true&"
import script from "./Schedule.vue?vue&type=script&lang=js&"
export * from "./Schedule.vue?vue&type=script&lang=js&"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=396b4554&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b4554",
  null
  
)

export default component.exports